import _ from "underscore";

module.exports = Backbone.Model.extend({
    defaults: {
        verlangt_andere_communicatie: false
    },

    initialize: function(options) {
        _.extend(this, options);
    },

    validation: function() {
        let validation = {
            voornaam: [{
                required: true,
                message: this.trans.firstname_error
            },{
                minLength: 2,
                maxLength: 40,
                message: this.trans.firstname_length_error
            },{
                fn: (value) => {
                    if (!_.isEmpty(value) && value.match(/^[\s]+$/)) {
                        return this.trans.firstname_error;
                    }
                    return true;
                }
            }],
            naam: [{
                required: true,
                message: this.trans.name_error
            },{
                minLength: 2,
                maxLength: 40,
                message: this.trans.name_length_error
            },{
                fn: (value) => {
                    if (!_.isEmpty(value) && value.match(/^[\s]+$/)) {
                        return this.trans.name_error
                    }
                    return true;
                }
            }],
            email: [{
                required: true,
                format: "email",
                message: this.trans.email_error
            }],
            text: [{
                required: true,
                message: this.trans.text_error
            },{
                fn: (value) => {
                    if (!_.isEmpty(value) && value.match(/^[\s]+$/)) {
                        return this.trans.text_error
                    }
                    return true;
                }
            }]
        };

        if (
            (typeof this.get("tel_nr") === "undefined" || this.get("tel_nr") === "") &&
            (typeof this.get("gsm_nr") === "undefined" || this.get("gsm_nr") === "")
        ) {
            _.extend(validation, {
                tel_nr: [{
                    required: true,
                    message: this.trans.tel_error
                }]
            });
        } else {
            if (typeof this.get("tel_nr") !== "undefined" && this.get("tel_nr") !== "") {
                _.extend(validation, {
                    tel_nr: [{
                        fn: (value) => {
                            if (!_.isEmpty(value) && value.match(/^[\+\s0-9\/]*$/)) {
                                return true;
                            }
                            return this.trans.tel_format_error
                        }
                    }]
                });
            }
            if (typeof this.get("gsm_nr") !== "undefined" && this.get("gsm_nr") !== "") {
                _.extend(validation, {
                    gsm_nr: [{
                        fn: (value) => {
                            if (!_.isEmpty(value) && value.match(/^[\+\s0-9\/]*$/)) {
                                return true;
                            }
                            return this.trans.gsm_format_error
                        }
                    }]
                });
            }
        }
        return validation;
    }

});